(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('EpmParams', EpmParams);

    EpmParams.$inject = ['$resource'];

    function EpmParams ($resource) {
        var resourceUrl =  'api/epm-params/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
